import React from 'react';
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import FacilitiesSearch from "../../components/FacilitiesSearch/FacilitiesSearch";
import store from "../../store";
import {Helmet} from "react-helmet";

const Facilities = () => {
  return (
    <div className="wrapper">
        <Helmet>
            {
                store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                    return row.rowTitle === "Ship" ? row.sections.map((section) => {
                        return section.title === "Facilities" ? <meta name="description" content={section.content['seo-description']}/> : null
                    }) : null
                }) : null
            }
        </Helmet>
      <Breadcrumbs/>
      <FacilitiesSearch/>
    </div>
  )
};

export default Facilities;



// WEBPACK FOOTER //
// ./src/pages/ship/Facilities.js